import { addAlphaComponent } from './alpha';

/**
 * Generates a consistent drop-shadow for the given color and size. The size is in px and defines
 * the spread of the shadow. The generated CSS covers one shadow per side to allow for a sharp
 * shadow contrast while keeping it tight to the element, so don't set size too large or it'll
 * look bad.
 * @param color The color to add 60% transparency to. Valid values are the same as
 *        those defined in {@link addAlphaComponent}.
 * @param size The size of the drop shadow to compute, in px.
 * @returns Returns a string of 4 drop-shadow rules to be used in a CSS filter:
 *          rule.
 */
export default function getDropShadow(color: string, size = 1.5) {
  const newColor = addAlphaComponent(color, 0.6);
  const rem = size / 16;
  const offset = `${rem}rem`;
  const depth = `${rem / 2}rem`;

  return `drop-shadow(${offset} 0 ${depth} ${newColor})
          drop-shadow(0 ${offset} ${depth} ${newColor})
          drop-shadow(-${offset} 0 ${depth} ${newColor})
          drop-shadow(0 -${offset} ${depth} ${newColor})
        `;
}
